import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import { fetchUserInformation } from "../../shared/actions/AuthActions";
import {
  View,
  TouchableOpacity,
  FlatList,
  ActivityIndicator,
} from "react-native-web";
import { emailValidator, getInitials } from "../../shared/core/utils";
import forGotPasswordApi from "../../shared/services/ForgotPasswordServices";
import Settings from "../../shared/config/Settings";
import ReCAPTCHA from "react-google-recaptcha";
import { appServices } from "../../shared/redux/actions/appServices";
import PortalAlerts from "../../app/components/PortalAlerts";
import Analytics from "../../shared/config/Analytics";
const ForgetPassword = (props) => {
  const dispatch = useDispatch();

  const [isForgetPassword, setIsForgetPassword] = useState(false);
  const [recaptchToken, setrecaptchToken] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const recaptchaRef = useRef();
  const navigate = useNavigate();
  const { ForgotPasswordData, isForgotPasswordData } = useSelector(
    (state) => state.ForgotPassword
  );
  const resetPassword = (e) => {
    setErrorMessage("");

    var email = document.getElementById("useName").value;

    const emailError = emailValidator(email);
    if (emailError) {
      setErrorMessage("You have entered an invalid email address.");
      return;
    }
    if (!recaptchToken) {
      setErrorMessage("Please complete the reCAPTCHA to proceed.");
      return;
    }

    passAuthServer(email);
  };

  //***************************************************************** api call server auth***********************************
  const passAuthServer = (email) => {
    setIsForgetPassword(true);
    const payload = {
      Username: email,
    };
    dispatch(appServices.ForgotPassword(payload));
  };
  useEffect(() => {
    if (ForgotPasswordData) {
      if (ForgotPasswordData.StatusCode == "1") {
        console.log("messageSent" + JSON.stringify(ForgotPasswordData));
        PortalAlerts("success", "success", ForgotPasswordData.ResponseMessage);
        setIsForgetPassword(false);
        Analytics.sendEvent({
          name: 'Rest Password',
          params: {
            method: 'email', 
            status: 'success',
          },
        });
      } else if (ForgotPasswordData.StatusCode == "0") {
        setErrorMessage(ForgotPasswordData.ResponseMessage);
        console.log(
          "messageSent status 0" + JSON.stringify(ForgotPasswordData)
        );
        setIsForgetPassword(false);
      } else {
        setErrorMessage("Something went wrong. Please try again.");
        setIsForgetPassword(false);
      }
    }
  }, [ForgotPasswordData]);

  //***************************************************************** End of call server auth***********************************
  const onChangeRecaptch = (value) => {
    console.log("Captcha value:", value);
    setrecaptchToken(value);
  };
  const onExpired = () => {
    setrecaptchToken(""); // Reset verification status when reCAPTCHA expires
    setErrorMessage("");
    // document.getElementById("errorMessage").innerHTML = ""
  };
  return (
    <div className="authentication-theme auth-style_1">
      <div className="row">
        <div className="col-12 logo-section">
          <a href="#" className="logo">
            <img
              src="https://devnhlapp.indici.ie/Images/mainLogo-indici-140X40.svg"
              alt="logo"
            />
          </a>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-5 col-md-7 col-sm-9 col-11 mx-auto">
          <div className="grid">
            <div className="grid-body">
              <div className="row">
                <div className="col-lg-7 col-md-8 col-sm-9 col-12 mx-auto form-wrapper">
                  <div className="form-group input-rounded">
                    <input
                      id="useName"
                      type="text"
                      className="form-control"
                      placeholder="Enter your email."
                    />
                  </div>

                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={Settings.recaptchaKey}
                    onChange={onChangeRecaptch}
                    onExpired={onExpired}
                    // theme='dark'
                    badge="inline"
                  />
                  <div className="form-group input-rounded">
                    <p id="errorMessage" style={{ color: "red" }}>
                      {errorMessage ?? ""}
                    </p>
                  </div>
                  {isForgetPassword && (
                    <View style={{ textAlign: "center", marginBottom: 5 }}>
                      <ActivityIndicator size="small" color="#00A1DE" />
                    </View>
                  )}

                  <button
                    onClick={(e) => resetPassword(e)}
                    type="submit"
                    className="btn btn-primary btn-block"
                  >
                    {" "}
                    Send Link{" "}
                  </button>

                  <div className="signup-link">
                    <Link to="/">Sign In</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="auth_footer">
        <p className="text-muted text-center">© indici 2020</p>
      </div>
    </div>
  );
};

export default ForgetPassword;
